<template>
  <div class="data-form-panel-v">
    <template v-if="items && items.length">
      <el-form size="mini"
               label-position="top">
        <el-row v-for="(row, rowIndex) in groupedItems"
                :key="`row-${rowIndex}`"
                :gutter="16"
                type="flex">
          <el-col v-for="(item, colIndex) in row"
                  :key="`form-item-${rowIndex}-${colIndex}`"
                  :span="item.fullLine ? 24 : formSpan">
            <el-form-item>
              <template #label>
                <span>{{item.label}}</span>
              </template>
              <DataFieldV v-bind="item.field"></DataFieldV>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>
    <template v-else>
      <Hint type="empty">
        <div>表单项数量为空</div>
      </Hint>
    </template>
  </div>
</template>

<script>
import DataFieldV from '../DataFieldV'
import Hint from '../../Hint'
import { addResizeListener, removeResizeListener } from 'element-ui/lib/utils/resize-event'
export default {
  name: 'FormPanel',
  components: {
    DataFieldV,
    Hint
  },
  props: {
    items: Array,
    inputStyle: String
  },
  provide () {
    return {
      $formPanel: this
    }
  },
  data () {
    return {
      formSpan: 8,
      cols: [1, 2, 3, 4, 6, 8, 12],
      colSize: 200
    }
  },
  computed: {
    isBorderStyle () {
      return this.inputStyle === 'border'
    },
    imageUrls () {
      if (!this.items || !this.items.length) {
        return []
      }
      return this.items
        .filter(item => item.field && item.field.type === 'image' && item.field.url)
        .map(item => item.field.url)
    },
    groupedItems () {
      if (!this.items || !this.items.length) {
        return []
      }
      const groups = []
      let currentGroup = []
      for (let i = 0; i < this.items.length; i++) {
        const item = this.items[i]
        if (item.nextLine && currentGroup.length > 0) {
          groups.push(currentGroup)
          currentGroup = []
        }
        currentGroup.push(item)
      }
      if (currentGroup.length > 0) {
        groups.push(currentGroup)
      }
      return groups
    }
  },
  methods: {
    handleResize () {
      let el = this.$el
      if (el) {
        let width = el.clientWidth
        if (width) {
          this.formSpan = this.getSpan(width)
        }
      }
    },
    getSpan (width) {
      for (let col of this.cols) {
        let span = 24 / col
        if (span * this.colSize <= width) {
          return col
        }
      }
      return 24
    }
  },
  mounted () {
    addResizeListener(this.$el, this.handleResize)
    this.handleResize()
  },
  beforeDestroy () {
    removeResizeListener(this.$el, this.handleResize)
  }
}
</script>

<style lang="scss" scoped>
.data-form-panel-v {
  height: 100%;
  padding: 12px;
  background-color: #fff;

  ::v-deep .el-row {
    display: flex;
    flex-wrap: wrap;
  }

  ::v-deep .el-form-item {
    margin-bottom: 12px;

    .el-form-item__label {
      padding-bottom: 2px;
      font-size: 13px;
      color: #606266;
    }

    .el-form-item__content {
      font-size: 13px;
      color: #303133;
    }
  }
}
</style>
